import React from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";
import { getPageDisplayName } from "./pageNameMapper";

const PagePerformanceChart = ({ data, days, isLoading, onDaysChange }) => {
  // Map data to use friendly names
  const displayData = data.map(item => ({
    ...item,
    name: getPageDisplayName(item.page)
  }));

  const getSubtitle = () => {
    if (days === 'today') return 'Top pages by visit count today';
    return `Top pages by visit count over last ${days} days`;
  };

  return (
    <div className="chart-card chart-card-full">
      <div className="chart-header">
        <div className="chart-header-with-select">
          <div>
            <h3>Page Performance Comparison</h3>
            <p>{getSubtitle()}</p>
          </div>
          <select
            className="days-selector"
            value={days}
            onChange={onDaysChange}
          >
            <option value="today">Today</option>
            <option value="7">Last 7 Days</option>
            <option value="10">Last 10 Days</option>
            <option value="15">Last 15 Days</option>
            <option value="30">Last 30 Days</option>
          </select>
        </div>
      </div>
      <div className="chart-container" style={{ position: 'relative' }}>
        {isLoading && (
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 10
          }}>
            <div className="spinner" style={{ width: '32px', height: '32px' }}></div>
          </div>
        )}
        <ResponsiveContainer width="100%" height={350}>
          <BarChart data={displayData} margin={{ top: 5, right: 30, left: 20, bottom: 80 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />
            <XAxis
              dataKey="name"
              stroke="#666"
              angle={-45}
              textAnchor="end"
              height={120}
              interval={0}
            />
            <YAxis stroke="#666" allowDecimals={false} />
            <Tooltip
              contentStyle={{
                backgroundColor: "#fff",
                border: "1px solid #ddd",
                borderRadius: "8px",
              }}
            />
            <Bar dataKey="visits" fill="#000066" name="Visits" radius={[8, 8, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default PagePerformanceChart;
